<template>
  <v-col class="metric-card">
    <v-row no-gutters class="d-flex icon-base align-items-center justify-content-center">
      <v-icon color="#33ac2e">mdi-check-bold</v-icon>
    </v-row>
    <v-row no-gutters class="mt-4">
      <span class="value">{{ formatNumber(value) }}{{ unit.length > 0 ? ' ' + unit : '' }}</span>
    </v-row>
    <v-row no-gutters class="mt-2">
      <h6>{{ description }}</h6>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: "NumericIndiactor",
  props: {
    value: {
      type: String,
      defeault: 0
    },
    unit: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  },
  methods: {
    formatNumber(number) {
      return new Intl.NumberFormat('is-IS', { maximumSignificantDigits: 3 }).format(number)
    }
  }
}
</script>

<style scoped>

.icon-base {
  width: 3.125rem;
  height: 3.125rem;
  background-color: rgba(140, 84, 255, 0.15);
  border-radius: 50%;
}

.value {
  font-size: 2.125rem;
  font-weight: 200;
  text-align: left;
  margin-bottom: 0;
}

h6 {
  font-weight: 0.9375rem;
  text-align: left;
  margin-bottom: 0;
}
</style>